import React from 'react';
import './FAQ.css';

const FAQ = () => {
  const faqs = [
    {
      question: "How long should I boil eggs?",
      answer: "The perfect boiling time depends on your preferred consistency: 3 minutes for dippy eggs with runny yolks, 6 minutes for jammy eggs perfect for ramen, 8 minutes for soft-boiled, and 10 minutes for hard-boiled eggs."
    },
    {
      question: "Should I start with cold or hot water?",
      answer: "Start with cold water and your eggs. Bring the water to a boil with the eggs in it. This helps prevent cracking and ensures even cooking."
    },
    {
      question: "How do I make perfect dippy eggs?",
      answer: "For perfect dippy eggs, use our timer set to 3 minutes. Start with room temperature eggs in cold water, bring to a boil, and use our timer. The whites will be set while the yolks remain perfectly runny."
    },
    {
      question: "Why use an online egg timer?",
      answer: "An online egg timer is specifically calibrated for eggs and provides precise timing for different consistencies. Our timer includes visual guides and notifications to help you achieve perfect results every time."
    },
    {
      question: "How do I prevent eggs from cracking?",
      answer: "Add eggs to cold water and heat gradually. You can also add a pinch of salt or vinegar to the water, which helps the egg whites coagulate quickly if there are any cracks."
    }
  ];

  return (
    <section className="faq-section">
      <h2>Frequently Asked Questions</h2>
      <div className="faq-grid">
        {faqs.map((faq, index) => (
          <div key={index} className="faq-item">
            <h3>{faq.question}</h3>
            <p>{faq.answer}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQ;
